import { Global } from '@emotion/react'
import { ecss } from '@signal/theme/emotion'

const globalCss = ecss`
  html, body {
    margin: 0;
    height: 100%;
    width: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
  }

  #root {
    height: 100%;
  }
`

export const GlobalStyle = () => <Global styles={globalCss} />

export default GlobalStyle
